export default __webpack_public_path__ + "static/media/ChronicleSSm-Book_Web.f2abf26e.woff2";